import { styled } from "@mui/material/styles";
import Check from "@bmi-digital/components/icon/Check";

const PREFIX = "PasswordCriteria";

export const classes = {
  criteriaMet: `${PREFIX}-criteriaMet`
};

export const StyledListWrapper = styled("ul")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  marginTop: "12px",
  marginBottom: "0",
  listStyleType: "none",
  paddingLeft: 0,
  rowGap: "6px",
  columnGap: "12px",
  [theme.breakpoints.down(376)]: {
    gridTemplateColumns: "1fr"
  }
}));

export const StyledListItem = styled("li")({
  fontSize: "16px",
  lineHeight: "22.41px",
  paddingLeft: "24px",
  paddingRight: "6px",
  position: "relative",
  alignSelf: "center",
  overflowWrap: "anywhere",
  display: "flex",
  gap: 6,
  alignItems: "center",
  "&::before": {
    position: "absolute",
    backgroundColor: "currentColor",
    content: '""',
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    left: "0",
    top: "50%",
    transform: "translateY(-50%)"
  },

  [`&.${classes.criteriaMet}`]: {
    paddingLeft: 0,
    "&::before": {
      display: "none"
    }
  }
});

export const StyledCheckIcon = styled(Check)(({ theme }) => ({
  fontSize: "18px",
  color: theme.colours.success400,
  stroke: "currentColor",
  strokeWidth: "1.5px"
}));
